import { useMemo, useState } from "react";
import { PRODUCTS } from "../data/content";
import { ProductCard, QuickViewModal, useWishlist } from "../sections/TheEdit";
import { Reveal, Tag } from "../components/Shared";
import { motion } from "framer-motion";

const FILTERS = ["All", "Ready to Wear", "Ethnic", "Bridal", "Men"];

export default function ShopPage() {
  const [filter, setFilter] = useState("All");
  const [quickView, setQuickView] = useState(null);
  const { wishlist, toggle } = useWishlist();

  const items = useMemo(
    () => (filter === "All" ? PRODUCTS : PRODUCTS.filter((p) => p.category === filter)),
    [filter]
  );

  return (
    <div className="bg-ink px-5 pb-32 pt-32 sm:px-10 md:pt-40" data-testid="shop-page">
      <div className="mx-auto max-w-[1600px]">
        <Reveal><Tag>The Shop</Tag></Reveal>
        <h1 className="mt-6 font-serif text-6xl font-light tracking-tight sm:text-7xl lg:text-8xl">
          THE EDIT<span className="text-flame">.</span>
        </h1>
        <Reveal delay={0.15}>
          <p className="mt-5 max-w-lg text-lg font-light text-fog">
            Ready when you are. Pieces from the current season — checkout and accounts arrive with the full store.
          </p>
        </Reveal>

        <div className="mt-12 flex flex-wrap gap-2 border-y border-line/10 py-5" data-testid="shop-filters">
          {FILTERS.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setFilter(f)}
              data-testid={`shop-filter-${f.toLowerCase().replace(/\s+/g, "-")}`}
              className={`px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.25em] transition-all duration-300 ${
                filter === f ? "bg-flame text-ink" : "text-fog hover:text-bone"
              }`}
            >
              {f}
            </button>
          ))}
          <span className="ml-auto self-center font-mono text-[10px] uppercase tracking-[0.25em] text-fog" data-testid="shop-count">
            {items.length} pieces
          </span>
        </div>

        <motion.div layout className="mt-14 grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((p, i) => (
            <Reveal key={p.id} delay={(i % 4) * 0.06}>
              <ProductCard p={p} onQuickView={setQuickView} wishlist={wishlist} onToggleWishlist={toggle} />
            </Reveal>
          ))}
        </motion.div>
      </div>
      <QuickViewModal product={quickView} onClose={() => setQuickView(null)} wishlist={wishlist} onToggleWishlist={toggle} />
    </div>
  );
}
